<div class="relative isolate grid w-full place-items-center overflow-hidden">
  <div class="pointer-events-none absolute bottom-0 left-0 top-0 z-10 w-[98px] bg-gradient-to-r from-background-white to-transparent"></div>
  <div
    class="pointer-events-none absolute bottom-0 right-0 top-0 z-10 w-[98px] bg-gradient-to-l from-background-white to-transparent"
  ></div>
  <div class="typo-h7-light text-text-black">{{ 'charting_add_treatment_tooth_title' | translate }}</div>
  <div
    class="flex w-[86px] flex-nowrap gap-5 transition-all md:w-[100px]"
    [style.translate]="'calc(var(--selected-index) * -1 * (100% + 20px))'"
    [style.--selected-index]="selectedIndex()"
  >
    @for (item of teeth; track item.position) {
      <button class="pointer-events-auto flex cursor-pointer flex-col items-center transition-all" (click)="onPageClick($index)">
        <div
          class="typo-h0 text-text-primary transition-transform"
          [ngClass]="{
            'translate-y-1/4 scale-75': selectedIndex() !== $index
          }"
        >
          {{ item.position }}
        </div>
        <lib-tooth
          class="w-[86px] transition-transform md:w-[100px]"
          [class.scale-75]="selectedIndex() !== $index"
          [tooth]="item"
          [toothOnly]="true"
          [cursorPointer]="true"
        />
      </button>
    }
  </div>
</div>
